import DefaultContainer from '../default_container';
import './index.css';
import { useRouteLocation, useLink } from 'react-router-stack';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGameToHistory, setMiniGamesData } from '../../actions/mini-games-action-types';
import { updateGameType } from '../../actions/user-actions-types';
import constants from '../../constants';
import GamesPosterCard from '../../component/games_poster_card';
import { isSmartPhone } from '../../utilities/helper';

const ViewAllGames = () => {
  const navigate = useLink();
  const location = useRouteLocation();
  const dispatch = useDispatch();
  const [gamesList, setGamesList]: any = useState([]);
  const [gameHeader, setGameHeader]: any = useState('');
  const { gamesHistory, miniGamesList = [] } = useSelector((state: any) => state.minigames);
  const quizGames = miniGamesList.filter((item: any) => item.category === 'quiz');
  const sportsGames = miniGamesList.filter((item: any) => item.category === 'sports');
  const arcadeGames = miniGamesList.filter((item: any) => item.category === 'arcade');
  const racingGames = miniGamesList.filter((item: any) => item.category === 'racing');
  const puzzleGames = miniGamesList.filter((item: any) => item.category === 'puzzles');
  const strategyGames = miniGamesList.filter((item: any) => item.category === 'strategy');

  useEffect(() => {
    const currentGame = location?.pathname.split('/')[2];
    getGamesList(currentGame);
  }, []);

  const getGamesList = (game: any) => {
    if (game === 'sports') {
      setGamesList(sportsGames);
      setGameHeader('Sports');
    }
    if (game === 'arcade') {
      setGamesList(arcadeGames);
      setGameHeader('Arcade');
    }
    if (game === 'racing') {
      setGamesList(racingGames);
      setGameHeader('Racing');
    }
    if (game === 'puzzles') {
      setGamesList(puzzleGames);
      setGameHeader('Puzzles');
    }
    if (game === 'quiz') {
      setGamesList(quizGames);
      setGameHeader('Quiz');
    }
    if (game === 'newgames') {
      setGameHeader('New Games');
      setGamesList(constants.MiniGames.newGamesList);
    }
    if (game === 'strategy') {
      setGameHeader('Strategy Games');
      setGamesList(strategyGames);
    }
    if (game === 'favourites') {
      setGameHeader('Favourite');
      setGamesList(miniGamesList);
    }
    if (game === 'all') {
      setGameHeader('All Games');
      setGamesList([
        ...sportsGames,
        ...arcadeGames,
        ...racingGames,
        ...puzzleGames,
        ...quizGames,
        ...strategyGames,
        ...constants.MiniGames.newGamesList
      ]);
    }
    if (game === 'singleplayer') {
      setGameHeader('Single Player Games');
      const singlePlayerGamesList = miniGamesList.filter(
        (item: any) => item.gameType !== 'playerVsPlayer'
      );
      setGamesList(singlePlayerGamesList);
    }
    if (game === 'multiplayer') {
      setGameHeader('Multi Player Games');
      const multiPlayerGamesList = miniGamesList.filter(
        (item: any) => item.gameType === 'playerVsPlayer'
      );
      setGamesList(multiPlayerGamesList);
    }
    if (game === 'cards') {
      setGameHeader('Cards');
      setGamesList(constants.MiniGames.cardsGame);
    }
    if (game === 'history') {
      setGameHeader('History');
      setGamesList([...gamesHistory]);
    }
  };

  const suggestionsHandler = (gameData: any) => {
    if (gameData.gameName === 'Poker') {
      navigate.push('/poker');
      dispatch(addGameToHistory(gameData));
    } else if (gameData.gameName === 'Fantasy Cricket') {
      dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
      dispatch(addGameToHistory(gameData));

      navigate.push('/fantasy', {
        title: 'Fantasy Cricket',
        gameType: constants.GameType.FANTASY_CRICKET
      });
    } else if (gameData.game === 'yesorno') {
      dispatch(updateGameType(constants.GameType.FANTASY_YES_NO));
      navigate.push('/fantasy', {
        title: 'Fantasy Yes/No',
        gameType: constants.GameType.FANTASY_YES_NO
      });
    } else if (gameData.game === 'football') {
      dispatch(updateGameType(constants.GameType.FANTASY_FOOTBALL));
      navigate.push('/fantasy', {
        title: 'Fantasy Football',
        gameType: constants.GameType.FANTASY_FOOTBALL
      });
    } else {
      dispatch(setMiniGamesData(gameData));
      navigate.push('/prizes');
    }
  };

  return (
    <DefaultContainer
      isWelcomeMessage={false}
      navigationTitle={`${gameHeader.split(' ')[0]} Games`}
      isNavigationHeader={true}>
      <div className="view_all_games_wrapper">
        {!isSmartPhone && (
          <div className="view_all_games_game_header">
            <p>{gameHeader}</p>
          </div>
        )}
        <div
          className={
            isSmartPhone ? 'view_all_games_card_wrapper_mWeb' : 'view_all_games_card_wrapper_web'
          }>
          {gamesList && gamesList.length > 0 ? (
            gamesList.map((item: any, idx: any) => (
              <React.Fragment key={idx}>
                <GamesPosterCard
                  item={item}
                  idx={idx}
                  onGamePosterClick={suggestionsHandler}
                  isFooter={false}
                />
              </React.Fragment>
            ))
          ) : (
            <div className="viewAll_noGamesWrapper_web">No Games Found</div>
          )}
        </div>
      </div>
    </DefaultContainer>
  );
};

export default ViewAllGames;
